export default [
    {
        path: "/invoices",
        name: "export invoices",
        component: require("../components/modules/exports/InvoiceList.vue")
            .default,
    },
];
